export enum SalesType {
    AUCTION = 'AUCTION',
    FIXED_PRICE = 'FIXED_PRICE',
    T_DROP = 'FIXED_PRICE_TDROP'
}
